module.exports = __webpack_public_path__ + "static/media/Terms and conditions qfx.74c0c851.pdf";